import styled, { css } from 'styled-components';

export const Item = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: 240px;
  height: 100%;
  min-height: 152px;
  flex-shrink: 0;
  border: 2px solid ${(props) => props.theme.border};
  cursor: pointer;

  ${(props) =>
    props.isSelected &&
    css`
      border: 2px solid ${(props) => props.theme.borderOnSelected};
    `}
`;

export const ImageHolder = styled.div`
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  background: ${(props) => props.theme.background};
`;

export const Image = styled.img`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Video = styled.video`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoIcon = styled.i`
  position: absolute;
  bottom: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.color};
  font-size: 33px;
`;

export const Placeholder = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 72px;
`;
